import { Container, Row, Col, Card, Image } from "react-bootstrap";
import EnquiryForm from "../components/Enquiry/EnquiryForm";
import heroImage from "../Assets/Images/enroll-banner.jpg"; // Use any nice SVG/PNG image

/*
 * Converted to utilities in Phase 5; enroll.scss deleted in the same commit.
 *
 * That sheet was DEAD: its only rule was `.enroll-hero-bg`, and this page has
 * never rendered that class — the gradient was written inline, in two hardcoded
 * hexes, so the public enrolment landing was light-only and the stylesheet
 * scoping `.card` (the fix recorded in Phase 4.1) applied to nothing.
 *
 * The gradient is the same shape against tokens now, so it follows the theme.
 */
const EnrollPage = () => {
  return (
    <div className="tw-min-h-screen tw-bg-gradient-to-r tw-from-surface-sunken tw-to-surface-hover">
      <Container className="py-5">
        {/* Hero Section */}
        <Row className="align-items-center mb-5">
          {/* <Col md={6} className="mb-4 mb-md-0">
            <h2 className="display-5 fw-bold mb-3">
              Start Your Learning Journey!
            </h2>
            <p className="lead text-secondary mb-4">
              Unlock your potential with our industry-ready courses. Fill out
              the form and our team will help you get started.
            </p>
            <ul className="list-unstyled mb-0">
              <li className="mb-2">
                <span className="fw-semibold">✔ Personalized guidance</span>
              </li>
              <li className="mb-2">
                <span className="fw-semibold">✔ 100% Placement Assistance</span>
              </li>
              <li>
                <span className="fw-semibold">
                  ✔ Live Projects & Certifications
                </span>
              </li>
            </ul>
            
          </Col> */}
          <Col md={12} className="text-center">
            <Image
              src={heroImage}
              alt="Enroll Now"
              fluid
              style={{ maxHeight: 400 }}
            />
          </Col>
        </Row>

        {/* Enquiry Form Section */}
        <Row className="justify-content-center">
          <Col lg={10} md={10}>
            <p className=" text-center text-muted mt-4 mb-4" style={{ fontSize: 15 }}>
              Fill out the form below and our admissions team will get in touch
              soon!
            </p>
            <EnquiryForm isGlobal={true} />
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default EnrollPage;
